import { Component, OnInit, Input} from '@angular/core'; // Adicionei para o checkbox Output e EventEmitter
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AccountClientDetailsService } from '../../../service/account-client-edit/account-client-details.service';
import { DocumentType } from '../../../../models/document-type';
import { FlashMessagesService } from 'angular2-flash-messages';
import { saveAs } from 'file-saver';
import { ConfirmComponent } from "../../../../shared/confirm/confirm.component";
import { DialogService } from "ng2-bootstrap-modal";

import * as moment from 'moment';
import 'moment/locale/pt-br';
import { IMyDpOptions } from 'mydatepicker';
//import { AttachmentGridComponent } from './attachment-grid/attachment-grid.component';


// Service
import { AttachmentListService } from '../../../../attachment/service/attachment-list/attachment-list.service';

@Component({
	selector: 'app-attachment-account-client',
	templateUrl: './attachment-account-client.component.html',
	styleUrls: ['./attachment-account-client.component.scss']
})
export class AttachmentAccountClientComponent implements OnInit {

	@Input('accountClientID') accountClientID: string = "";
	@Input('clientName') clientName: string = "";
	@Input('isProposal') isProposal: boolean = false;



	public guid: string;
	private sub: any;

	private fichaCadastral: any[] = [];
	private documentos: any[] = [];
	private impostoDeRenda: any[] = [];
	private certidoesMatriculas: any[] = [];
	private documentosGarantidores: any[] = [];
	private garantias: any[] = [];
	private contratos: any[] = [];
	private demonstracoesFinanceiras: any[] = [];
	private estatutoContratoSocial: any[] = [];
	private documentosSociosAcionistas: any[] = [];
	private consultasSerasa: any[] = [];
	private consultasTj: any[] = [];
	private outros: any[] = [];
	private documentacaoHistorica: any[] = [];

	public documentTypes: DocumentType;
	private permissoes = [];
	public descAttach: string = "";
	public docTypeAttach: string = "";
	public selectedFileName: string = "Selecionar Arquivo...";
	public complementAttach: string = "";
	
	public attachSubcription;
	private allAttachs: any[] = [];

	private today = moment();

	private token;
	public orderby: string = "Descricao";
	public sort: string = "asc";
	public attachments: any[] = [];
	currentPage: number = 0;

	selectedIds: string[] = [];

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
		disableUntil: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		//height: "30px"
	};

	constructor(private accountClientDetailsService: AccountClientDetailsService, private attachmentListService: AttachmentListService, private dialogService: DialogService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
		this.token = localStorage.getItem('yara.token');
		this.documentTypes = new DocumentType();
	}

	ngOnInit() {
		this.sub = this.route.params.subscribe(params => {
			this.guid = params['guid'];
		});

		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

		this.attachSubcription = this.accountClientDetailsService.attachmentReload.subscribe(value => {
			this.getClientAttachments(value);
		});

		this.getClientAttachments(null);
	}

	getClientAttachments(order) {
		this.accountClientDetailsService.getClientAttachments(this.guid).subscribe(result => {
			if (result.Success) {

				this.allAttachs = result.Result;

				console.log('this.allAttachs: ', this.allAttachs);

				for (var i = 0; i < result.Result.length; i++) {
					result.Result[i].Comentario = result.Result[i].Comentario === null ? "" : result.Result[i].Comentario;
					result.Result[i].Origem = result.Result[i].PropostaLCID ? 'Proposta LC' : (result.Result[i].PropostaLCAdicionalID ? 'Proposta LCA' : 'Conta Cliente');
					result.Result[i].DescricaoAnexo = result.Result[i].Anexo.Descricao;
					result.Result[i].Status = result.Result[i].Status === null ? -1 : result.Result[i].Status;

					// Checkbox[ADICIONAR] após a linha 120 (ainda dentro do laço for)
					if (typeof result.Result[i].selected === 'undefined') {
						result.Result[i].selected = false;
					}// Fim Checkbox
					

					if (result.Result[i].DataValidade) {
						result.Result[i].DataValidadeOriginal = result.Result[i].DataValidade;
						const tempMoment = moment(result.Result[i].DataValidade);
						result.Result[i].DataValidade = { date: { year: tempMoment.year(), month: tempMoment.month() + 1, day: tempMoment.date() } };
					} else {
						result.Result[i].DataValidadeOriginal = '0001-01-01'; // se vazio, coloca a menor data possivel para funcionar o orderby
					}
				}

				if (order) {

					let property = order.property;
					let direction = order.direction;

					this.allAttachs.sort(function(a, b){

						if (a[property] < b[property]) {
							return -1 * direction;
						}
						else if (a[property] > b[property]) {
							return 1 * direction;
						}
						else{
							return 0;
						}
					});
				}
				
				// [ADICIONAR] após a linha 155
			//	this.syncSelectAllState();

				this.fichaCadastral = result.Result.filter(item => item.Anexo.CategoriaDocumento === 1)
				this.documentos = result.Result.filter(item => item.Anexo.CategoriaDocumento === 2);
				this.impostoDeRenda = result.Result.filter(item => item.Anexo.CategoriaDocumento === 3);
				this.certidoesMatriculas = result.Result.filter(item => item.Anexo.CategoriaDocumento === 4);
				this.documentosGarantidores = result.Result.filter(item => item.Anexo.CategoriaDocumento === 5);
				this.garantias = result.Result.filter(item => item.Anexo.CategoriaDocumento === 6);
				this.contratos = result.Result.filter(item => item.Anexo.CategoriaDocumento === 7);
				this.demonstracoesFinanceiras = result.Result.filter(item => item.Anexo.CategoriaDocumento === 8);
				this.estatutoContratoSocial = result.Result.filter(item => item.Anexo.CategoriaDocumento === 9);
				this.documentosSociosAcionistas = result.Result.filter(item => item.Anexo.CategoriaDocumento === 10);
				this.consultasSerasa = result.Result.filter(item => item.Anexo.CategoriaDocumento === 11);
				this.consultasTj = result.Result.filter(item => item.Anexo.CategoriaDocumento === 12);
				this.outros = result.Result.filter(item => item.Anexo.CategoriaDocumento === 13);
				this.documentacaoHistorica = result.Result.filter(item => item.Anexo.CategoriaDocumento === 14);

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	setFile() {
		var input: any = document.getElementById("fileAttach");
		var file = input.files[0];
		this.selectedFileName = file.name;
	}

	fileSelected() {
		var input: any = document.getElementById("fileAttach");

		if (!this.docTypeAttach) {
			this.flashMessagesService.show("Selecione uma Categoria", { cssClass: 'alert-danger', timeout: 6000 });
		} else if (!this.descAttach) {
			this.flashMessagesService.show("Preencha uma Descrição", { cssClass: 'alert-danger', timeout: 6000 });
		} else if (!input.files[0]) {
			this.flashMessagesService.show("Selecione um arquivo", { cssClass: 'alert-danger', timeout: 6000 });
		} else {
			var file = input.files[0];
			this.uploadAttachment(file);
		}
	}

	
	
		
	//Fuction to upload the attachment, receive the index of attachmentList obj
	uploadAttachment(file) {
		var formData = new FormData();

		formData.append('Arquivo', file);
		formData.append('PropostaLCID', '');
		formData.append('AnexoID', '');
		formData.append('ContaClienteID', this.accountClientID);
		formData.append('CategoriaDocumento', this.docTypeAttach);
		formData.append('DescricaoAnexo', this.descAttach);
		formData.append('Complemento', this.complementAttach);


		this.accountClientDetailsService.uploadAttachClient(formData).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Anexo enviado com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				this.getClientAttachments(null);
				$("#fileAttach").val("");
				this.docTypeAttach = "";
				this.descAttach = "";
				this.complementAttach = '';
				this.selectedFileName = "Selecionar Arquivo...";
			} else {
				$("#fileAttach").val("");
				this.selectedFileName = "Selecionar Arquivo...";
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	downloadAttachmentZip(index) {
		
		this.accountClientDetailsService.downloadAttachmentZip(this.accountClientID,null).subscribe(blob => {
			if (blob) {
				saveAs(blob, this.clientName + ".zip");
			} else {
				this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	downloadAttachmentZipSelecao(index) {
		
		this.accountClientDetailsService.downloadAttachmentZip(this.accountClientID,this.selectedIds).subscribe(blob => {
			if (blob) {
				saveAs(blob, this.clientName + ".zip");
			} else {
				this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	searchAttachment() {

		this.orderby = "Descricao";
		this.sort = "asc";
		this.currentPage = 0;

		this.attachmentListService.searchAttachmentByCategory(this.token, this.docTypeAttach, true, this.orderby, this.sort, 1).subscribe(result => {
			if (result.Success) {
				this.attachments = result.Result;

			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	onSelectedIdsChange(objIds) {
		var idsToAdd = objIds.selectedIds;
	
		if(this.selectedIds.length > 0)
		{
			this.selectedIds = this.selectedIds.concat(idsToAdd.filter(id => !this.selectedIds.includes(id)));
			this.selectedIds = this.selectedIds.filter(id => !objIds.idsToRemove.includes(id));
		} else
			this.selectedIds = idsToAdd;

		
	}

	inactivateAttachmentSelected(id) {
		
	    let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmação',
			message: 'Confirma a exclusão do anexo?',
			warning: "Essa ação não poderá ser revertida."
		},
			{
				backdropColor: 'rgba(0, 0, 0, 0.5)'
			}).subscribe((isConfirmed) => {
				//We get dialog result
				if (isConfirmed) {
					this.accountClientDetailsService.inactivateAttachmentList(this.accountClientID,this.selectedIds).subscribe(result => {
					if (result.Success) {
						this.flashMessagesService.show("Anexo removido com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
						this.getClientAttachments(null);
					} else {
						this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
					}
				}, error => {
					console.log(error);
				});

				}
				else {
					//Do nothing here for now
				}
			});
			
	}

	// canEditAttachment(){
	// 	if (this.profileUser === 'Estagiário de Crédito' ||
	// 	profileUser === 'Assistente de Crédito' ||
	// 	profileUser === 'Analista de Crédito' ||
	// 	profileUser === 'Coordenador de Crédito' ||
	// 	profileUser === 'Gerente de Crédito'){

	// 	}
	// }


}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/attachment-account-client/attachment-account-client.component.ts